import logger from '../../services/logger';
import { PageTitle } from "../common/Header"; 

import { Geev, Ecosystem} from "../common/Icon";
import React, {useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import "../../css/entretienproduct.css";

import { useLocation} from 'react-router-dom';
import { Button } from "react-bootstrap"; 


import Navigation from "../navigation";
import Header from "../common/Header";

import { getGeevCateg} from "../../services/glossary.service";

const Give = () => {
    const location = useLocation();
    const { state } = location|| {}; // S'assurer que state est un objet si location.state est null;
    const { product } = state|| {}; // S'assurer que state n'est pas null avant de déstructurer
    logger.log("appareil reçu ",product);

    //const navigate = useNavigate();
  
  useEffect(() => {
    logger.log('Dans inventaire des produits');
    document.body.style.backgroundColor = '#ffffff';
  }, []); // Le tableau vide en second paramètre signifie que useEffect s'exécutera une fois après le montage initial

  const handleClicktoGive = (product) => {
    const categ=getGeevCateg(product.prod_name);
    window.open('https://www.geev.com/fr/recherche/objets?categories='+categ, '_blank');
  };

  const handleClicktoEcosystem = () => {
    // Rediriger vers la page CardDetail et passer l'objet maintenanceCard
    //?product=Aspirateur&location=Paris%252C%2BFrance&lat=48.856614&lon=2.3522219
    const location ='location=Paris%252C%2BFrance&lat=48.856614&lon=2.3522219';
    const categ= 'product='+product.prod_name;
    window.open(' https://www.ecosystem.eco/donner-recycler/?'+categ+'&'+location, '_blank');
  };

  
  return (
    <div className="mb-4 p-0">
    <Header/>  
    <PageTitle title={`Deuxième vie : ${product.prod_name}`} />
      <div className="">
          <Navigation/>
            <div className="d-flex row m-0 g-3"> 
                <div className="col-12 col-md-6 col-lg-6">
                  <div className="p-3 dark-green-background mx-auto d-block mt-3 d-flex flex-column" style={{ minHeight: "100%" }}>                 
                    <h1 className="mt-3" style={{ fontSize: "1.2rem", fontWeight: "700", color: "white" }}>
                      Je donne à un particulier
                    </h1>
                    <br/>
                    <Geev style={{ width: "120px", height: "auto" }} />
                    

                    <div className="text-left mt-3 mb-3" style={{ flex: 1 }}>
                      <p
                        style={{
                          fontSize: "1rem",
                          fontWeight: "400",
                          lineHeight: "2",
                          color: "white" 
                        }}
                      >
                        En choisissant Geev pour donner votre appareil, vous participez non seulement à la réduction
                        des déchets, mais vous soutenez également l'économie circulaire. <br /> Cette plateforme innovante
                        conçue pour faciliter le don d'objets entre particuliers, est pratique, locale, et engagée
                        dans la lutte contre le gaspillage, offrant une solution écologique et économique à ses
                        utilisateurs.
                      </p>
                    </div>

                    <Button
                      className="mt-auto mx-auto d-block mb-3 btn-secondary"
                      onClick={() => handleClicktoGive(product)}
                    >
                      Je donne avec
                      <Geev
                        style={{ width: "50px", height: "auto", marginLeft: "8px" }}
                      />
                    </Button>
                  </div>
                 
                </div>

            
               
                <div className="col-12 col-md-6 col-lg-6">
                  <div className="p-3 yellow-background mx-auto d-block mt-3 d-flex flex-column" style={{ minHeight: "100%" }}>                 
                    <h1 className="mt-3" style={{ fontSize: '1.2rem', fontWeight: '700',}} alignTe>Je donne à un point de collecte</h1>
                    <br/>
                    <Ecosystem style={{width: '150px', height: 'auto' }} />
                      <div className="text-left mt-3 mb-3" style={{ flex: 1 }}>
                        <p className="text-left mb-3" style={{
                                      fontSize: '1rem',
                                      fontWeight: '400',
                                      lineHeight: "2",
                                  }}>Ecosystem est une organisation dédiée à la promotion du recyclage électronique et au don d'appareils encore utilisables pour minimiser l'impact environnemental.<br/> En choisissant de donner votre appareil via Ecosystem, vous facilitez son accès à des entités qui peuvent le réutiliser ou le recycler de manière responsable. <br /> Ce geste aide à conserver des ressources naturelles précieuses et à éviter la pollution liée à la production de nouveaux matériaux.</p>

                      </div>
                      
                      <Button 
                          className="mt-auto mx-auto d-block mb-3 btn-secondary"
                          onClick={() => handleClicktoEcosystem(product)}
                      >Je donne avec 
                        <Ecosystem
                          style={{ width: "100px", height: "auto", marginLeft: "8px" }}
                        />
                      </Button>  

                  </div>
                </div>
               
              </div>
               <br/>
                <br/>
            </div>
          </div>
  );
};

export default Give;